<template>
  <div class="select-options">
    <label v-if="selectHeaderLabel"> {{ selectHeaderLabel }} </label>
    <template v-if="displayIconInsteadOfLabel">
      <font-awesome-icon :icon="displayIconInsteadOfLabel"/>
    </template>
    <button
      class="dropdown-toggle btn btn-sm k-selected-value"
      :class="{'select-button-full-width': useFullWidthClass}"
      type="button"
      :style="{ width: width + 'px' }"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      v-if="value[label]"
    >
      {{ value[label] }}
    </button>
    <button
      class="dropdown-toggle btn btn-sm k-selected-value icon-toggle"
      :class="{'select-button-full-width': useFullWidthClass}"
      type="button"
      :style="{ width: width + 'px'}"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      v-if="value.icon"
    >
      <font-awesome-icon :icon="getIconFromName(value.icon)"/>
    </button>
    <div  :style="style" class="dropdown-menu" aria-labelledby="dropdownMenuButton" :class="{'select-option-full-width': useFullWidthClass}">

      <div v-for="option in getOptions" :key="option[displayKey]"> 
        <a  
          v-if="option.label || label != 'label'"
          @click="select(option)"
          class="dropdown-item" :class="{'disabled': disabledUsingCondition(option)}" href="#">
            {{ option[label] }}
        </a>
        <a  
          v-else-if="option.icon"
          @click="select(option)"
          class="dropdown-item" :class="{'disabled': disabledUsingCondition(option)}" href="#">
            <font-awesome-icon :icon="getIconFromName(option.icon)"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SelectField',
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: false,
    },
    displayKey: {
      type: String,
      required: false,
      default: 'code'
    },
    label: {
      type: String,
      required: false,
      default: 'label'
    },
    isPremiumOptions: {
      type: Boolean,
      required: false,
      default: false
    },

    width: {
      type: Number,
      required: false,
      default: 160      
    },

    padding: {
      type: String,
      required: false,
      default: "1.5rem"            
    },
    selectHeaderLabel: {
      type: String,
      required: false,
      default: ""            
    },
    displayIconInsteadOfLabel: {
      type: String,
      required: false,
    },
    useFullWidthClass: {
      type: Boolean,
      default: false
    }
    

  },

  data() {
    return {
      displayValue : null
    };
  },

  computed: {
    getOptions() {
      return this.options;
    },
    ...mapGetters({
        getPollDesignId: 'getPollDesignId',
        isPremium: 'isPremium'
    }),

    style() {
      return  "width: "+ this.width + "px; min-width:" +  this.width + "px";
    },

    paddingStyle() {
      return  "padding-left: "+ this.padding + "; padding-right: " +  this.padding +";";
    },
  },

  watch: {
    options(newValue) {
      if(newValue && newValue.length > 0) {
        this.displayValue = newValue[0]
      }
    }
  },

  methods: {
      select(value) {
        this.$emit('input', value);
      },
      disabledUsingCondition(option) {
        if(this.isPremiumOptions == true) {
          if(this.isPremium || option.id == this.getPollDesignId || option.isDefault == 1) {
            return false;
          }
          return true;
        }
        return false;
      },
      getIconFromName(type) {
            let renderData = ['fas', 'check'];
            switch(type) {
                case "check" || "checked with parenthesis":
                    renderData = ['fas', 'check'];
                    break;
                case "times":
                    renderData = ['fas', 'times'];
                    break;
                case "question":
                    renderData = ['fas', 'question'];
                    break;
            }
            return renderData;
        },
  },

  mounted() {
    this.displayValue = this.value;
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/abstracts/variables';

.btn.k-selected-value {
  background-color: white !important;
  border: 1px solid grey;
  width: $btn-fixed-width;
  min-height: 33px;
}


.dropdown-menu {
  border-radius: 2px;
  padding-top: 8px;
  padding-bottom: 8px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  box-sizing: border-box;
  // width: $btn-fixed-width;
  touch-action: manipulation;
  width: 100%;
}


.dropdown-item:hover {
    background-color: $very-light-grey;
}

.select-options {
  width: 100%;
  position: relative;
  display: grid;
  label {
    font-size: $very-small;
  }
}

.icon-toggle {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center;
}

::v-deep .fa-check {
  color: $secondary;
}

.select-button-full-width {
  width: 100% !important;
  overflow: hidden;
  padding: unset;
}

.select-option-full-width {
  width: 100% !important;
  min-width: 100% !important;
  transform: translate3d(0px, 33px, 0px) !important;
  padding: unset;
}

</style>
